<template>
  <div class="app-main-container">
    <div class="app-main-inner">
      <transition>
        <keep-alive>
          <router-view>
          </router-view>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-main"
}
</script>

<style scoped>
.app-main-inner{
    margin: 10px;
    padding: 20px;
    border: 1px solid #E0E0E0;
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue